// generated file, if you want to edit this file manually change the word "generated" to "manual"
import MaterialTab from "@material-ui/core/Tab";
import React from "react";
import { makeThemedStyles } from "./../utils";
const useStyles = makeThemedStyles("BottomNaviTab", (theme) => ({
  root: {
    padding: "1.72em 1.14em",
    textTransform: "uppercase",
    fontWeight: "normal",
    fontSize: "1.6em",
    opacity: 1,
    borderLeft: "0px",
    border: "1px solid",
    borderImage:
      "linear-gradient(to bottom, rgb(61 122 133), rgba(19, 65, 70, 0)) 3 100%",
    minWidth: "15.5em !important",
    height: "10.7em",
    letterSpacing: "0.1em",
    transition: "all 0.5s",
    "&:before": {
      position: "absolute",
      content: '""',
      top: "7.2em",
      left: "0px",
      width: "100%",
      height: "0.22em",
      background: "rgb(17 94 103)",
      transition: "none",
      transform: "translate(0px, 1.78em) scaleX(0)",
      opacity: "0.5",
    },
    "&:hover": {
      "& img": {
        filter: "brightness(400%) grayscale(100%)",
      },
      color: "rgb(238 238 238)",
      background: "rgb(24 40 43 / 47%)",
      boxShadow: "0 0.23em 2.6em 0 rgb(0 0 0 / 3%)",
      "&:before": {
        position: "absolute",
        content: '""',
        top: "7.2em",
        left: "0px",
        width: "100%",
        height: "0.22em",
        background: "rgb(17 94 103)",
        transition: "all 0.5s",
        transform: "translate(0px, 1.78em) scaleX(0.16)",
      },
    },
    "& .MuiTabs-indicator": {
      transform: "translate(0px, -1.78em) scaleX(0.2) scaleY(0.9)",
      opacity: "0.8",
    },
    "& span": {
      fontWeight: "bold",
      letterSpacing: "1px",
      lineHeight: "1.4",
    },
  },
  selected: {
    boxShadow: "0 0.23em 2.6em 0 rgb(0 0 0 / 3%)",
  },
}));
type PropType = React.ComponentProps<typeof MaterialTab>;
export const BottomNaviTab: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStyles();
  return (
    <MaterialTab
      {...props}
      classes={{
        selected: styles.selected,
      }}
      className={styles.root}
    >
      {props?.children}
    </MaterialTab>
  );
};
export default BottomNaviTab;
